import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
    username: Yup.string().email('Must be a valid Email').required('Username is required'),
    password: Yup.string().required('Password is required')
});